package dev.danko.roblox_craft_ai.uikit.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** On/off switch with a label (`role="switch"`, toggles with click, Space or Enter). */
@Composable
fun AppSwitch(checked: Boolean, onCheckedChange: (Boolean) -> Unit, label: String, modifier: Modifier = Modifier) {
    val palette = LocalAppTheme.current.colors
    Button(
        modifier
            .styleModifier {
                property("display", "inline-flex")
                property("align-items", "center")
                property("gap", "10px")
                property("background", "transparent")
                property("border", "none")
                property("padding", "4px 0")
                property("cursor", "pointer")
                property("font", "inherit")
            }
            .color(palette.textPrimary)
            .onClick { onCheckedChange(!checked) }
            .toAttrs {
                attr("type", "button")
                attr("role", "switch")
                attr("aria-checked", checked.toString())
            }
    ) {
        Span(
            Modifier
                .width(36.px).height(20.px).borderRadius(999.px)
                .backgroundColor(if (checked) palette.accent else palette.borderStrong)
                .position(org.jetbrains.compose.web.css.Position.Relative)
                .styleModifier { property("transition", "background-color 150ms ease"); property("flex-shrink", "0") }
                .toAttrs()
        ) {
            Span(
                Modifier
                    .position(org.jetbrains.compose.web.css.Position.Absolute)
                    .top(2.px).left(if (checked) 18.px else 2.px)
                    .width(16.px).height(16.px).borderRadius(999.px)
                    .backgroundColor(palette.textPrimary)
                    .styleModifier { property("transition", "left 150ms ease") }
                    .toAttrs()
            )
        }
        Span(Modifier.fontSize(14.px).toAttrs()) { Text(label) }
    }
}
